import EncodeDecodeType from '../actiontype/encode-decode-type';
import OnlineEncodeDecodeService from './online-encdec.service';
import store from '../store/redux-store';
import GLOBAL_CONFIG from '../config/config';
import UtilService from './util.service';
import { LocalStorageService } from './localstorage.service';
import { NativeBridge } from './native-bridge';
import { BridgeAccessService } from './bridge-access.service';
import { SentryService } from './sentry-service';
import { ErrorCategories } from '../enums/error-categories.enum';
import { SentryMessages } from '../constants/sentry-messages.constant';

export default class CustomHttpConfigService {

    static addDefaultChatbotConfig(config) {

        this.addDefaultConfig(config);
        const state = store.getState();
        const mobileAppAuthToken = state.userInfo.mobileAppAuthToken;
        const loggedInNumber = state.userInfo.loggedInNumber;
        const selectedNumber = state.userInfo.selectedNumber;

        config["headers"]["Airtel-Auth-Domain"] = mobileAppAuthToken;


        if (loggedInNumber !== selectedNumber) {
            config["headers"]["sso-number"] = selectedNumber;
        }

    }

    static addDefaultOnlineConfig(config) {

        this.addDefaultConfig(config);

        if (!config["headers"]["adsHeader"]) {
            const key = OnlineEncodeDecodeService.generateEncryptionKeyForOTP();
            config["headers"]["adsHeader"] = key;
        }

    }

    static addDefaultHelpSupportConfig(config) {

        this.addDefaultOnlineConfig(config);

        config["baseURL"] = GLOBAL_CONFIG.baseUrls.HELPSUPPORT.default;

        // if the user is logged in
        if (store.getState().userInfo.authStatus && !UtilService.isMobileApp()) {
            config["baseURL"] = UtilService.getFullUrl([config["baseURL"], GLOBAL_CONFIG.authPrefixPath.HELPSUPPORT]);

            // Set access token header
            const accessToken = LocalStorageService.getAccessToken()
            config["headers"]["z-access-token"] = accessToken || "";
        }

        if (UtilService.isMobileApp()) {
            config["baseURL"] = UtilService.getFullUrl([config["baseURL"], "/app"]);
        }

    }

    static addDefaultConfig(config) {

        if (!config["timeout"]) {
            config["timeout"] = 30000;
        }
        if (!config["headers"]) {
            config["headers"] = {};
        }
        if (!config['headers']['Content-Type']) {
            config["headers"]["Content-Type"] = "application/json";
        }
    }

    static addNonMobileAppHeaders = (method, config) => {
        config.headers.googleCookie = "airtel.com";
        var key = OnlineEncodeDecodeService.generateEncryptionKeyForOTP();
        config.headers.adsHeader = key;
        if (method === "POST" && config.data && !(config.data.file || config.data.files)) {
            config.data = OnlineEncodeDecodeService.encryptDataToSHAString(JSON.stringify(config.data), key);
        }
    }

    static handleMobileAppHeaders = (method, config, encodeDecodeType) => {

        return _handleMobileAppHeaders(method, config, encodeDecodeType);

    }

    static addAppHeaders = (url, method, config) => {

        if(!config) {
            config = {}
        }
        
        const channelName = UtilService.getChannelName();
        let reqPayload = "";
        if (method !== 'GET' && config.data) {
            reqPayload = JSON.stringify(config.data);
            delete config.data
        }
        
        const apiRelativeUrl = url;
      
        //GET app Headers
        const appHeadersPromiseResponse = BridgeAccessService.getAppHeaders(method, apiRelativeUrl, reqPayload);
        return new Promise((resolve, reject) => {
            appHeadersPromiseResponse.then(appHeaders => {
                if(appHeaders) {
                    if(!config.headers) {
                        config.headers = {}
                    }
                    for (let key in appHeaders) {
                        config.headers[key] = String(appHeaders[key]).replace(/\n/g, '')
                    }
                    config.headers['requestSrc'] = "myAirtelApp";
                    config.headers['requesterId'] = channelName;
                }
                resolve(config)
            }).catch(e => {
                SentryService.captureException({errorInfo: e, message: SentryMessages.UNABLE_TO_FETCH_APP_HEADERS, errorCategory: ErrorCategories.OTHER})
                reject(e)
            })
        })
    }

    static getUrlForApp = (url) => {
        if (url) {
            if (url.charAt(url.length - 1) === '/') {
                url = url.substr(0, url.length - 1)
            }
        }
        return url;
    }

}



const _addMobileAppHeaders = (method, config) => {
    var reqPayload = "";
    if (method !== 'GET' && config.data) {
        reqPayload = JSON.stringify(config.data);
    }

    const apiRelativeUrl = UtilService.getFullUrl([config.baseURL, config.url]);

    //GET app Headers
    const appHeadersPromiseResponse = NativeBridge.getHeaders(config.method, apiRelativeUrl, reqPayload);

    appHeadersPromiseResponse.then(appHeaders => {
        config.headers["x-bsy-did"] = String(appHeaders["x-bsy-did"]).replace(/\n/g, '');
        config.headers["x-bsy-utkn"] = String(appHeaders["x-bsy-utkn"]).replace(/\n/g, '');
        config.headers["x-bsy-dt"] = String(appHeaders["x-bsy-dt"]).replace(/\n/g, '');

        config.headers['requestSrc'] = "myAirtelApp";
    })
}

const _addNonMobileAppHeaders = (method, config) => {
    config.headers.googleCookie = "airtel.com";
    var key = OnlineEncodeDecodeService.generateEncryptionKeyForOTP();
    config.headers.adsHeader = key;
    if (method === "POST" && config.data && !(config.data.file || config.data.files)) {
        config.data = OnlineEncodeDecodeService.encryptDataToSHAString(JSON.stringify(config.data), key);
    }
}

const _handleMobileAppHeaders = (method, config, encodeDecodeType) => {

    const channelName = UtilService.getChannelName();

    const isMobileApp = UtilService.isMobileApp();

    /*Add extra headers for mobile app*/
    if (isMobileApp) {
        _addMobileAppHeaders(method, config);

    } /*encrypt qa/dev/production build request for web app*/
    else {
        _addNonMobileAppHeaders(method, config);
    }

    // For external API's [Deleted headers]
    if (encodeDecodeType === EncodeDecodeType.DEFAULT) {
        delete config.headers.googleCookie;
        delete config.headers.adsHeader;
        delete config.headers.requesterId;
    }

    config.headers['requesterId'] = channelName;
}